import type { Loan as GQLItem } from '../../../generated/internal.graphql';
import { take } from '../../../util/takePayload';
import * as LoanPayment from './LoanPayment';

/**
 * A Soundcheck loan on the internal (VP staff) schema.
 *
 * Both paths that produce one — the staff account query and the `createSoundcheckLoan` mutation —
 * select `INTERNAL_SOUNDCHECK_LOAN_FIELDS` and map it through here, so the finance components only
 * ever hold this type. The AppSchema mapper this replaces is gone.
 */
export type Loan = {
  id: number;
  loanType: string;
  originalPrincipalBalance: number;
  outstandingBalance: number;
  perTicketFeePercentage?: number;
  status: string;
  createdAt: string;
  updatedAt: string;
  /** Amounts recouped against the loan, newest first. */
  loanPayments: LoanPayment.LoanPayment[];
};

export const fromGql = (item: GQLItem): Loan => ({
  ...take<Loan>(
    item,
    'id',
    'loanType',
    'originalPrincipalBalance',
    'outstandingBalance',
    'status',
    'createdAt',
    'updatedAt',
  ),
  perTicketFeePercentage: item.perTicketFeePercentage ?? undefined,
  // The field is non-null on the schema; the `??` is only there so a hand-rolled selection that
  // skipped it renders an empty history rather than throwing on `undefined.map`.
  loanPayments: (item.loanPayments ?? []).map(LoanPayment.fromGql),
});
